/**
 * Kadalys — assets/a11y-icons.js (LOT 2, point 5)
 *
 * snippets/icon.liquid rend les icônes Material en LIGATURES textuelles :
 *   <span class="... icon icon--arrow_forward" translate="no">arrow_forward</span>
 * Un lecteur d'écran énonce donc « arrow forward », « local mall », « menu ».
 * Aucune correction CSS n'est possible (aria-hidden et aria-label ne sont pas
 * des propriétés CSS), et icon.liquid est un fichier cœur de FullStack.
 * Ce script est donc la seule voie sans toucher aux fichiers cœur.
 *
 * Il n'AJOUTE que des attributs ARIA. Il ne déplace, ne supprime et ne
 * réécrit aucun nœud, ne modifie aucun style, n'ajoute aucune dépendance.
 * S'il ne s'exécute pas, la page se comporte exactement comme aujourd'hui.
 *
 * Règles appliquées :
 *  1. Icône SANS commande autour  -> décorative -> aria-hidden="true".
 *     (les pastilles eco / verified / diamond_shine / genetics de la home)
 *  2. Icône dans une commande qui a DÉJÀ un nom (texte visible, aria-label
 *     ou title) -> aria-hidden="true" sur la seule icône. C'est le cas des
 *     26 boutons « libellé + arrow_forward » de la home et de l'en-tête :
 *     « Découvrir la science arrow forward » devient « Découvrir la science ».
 *  3. Icône SEULE dans une commande -> on pose un aria-label français pris
 *     dans LIBELLES, puis on masque l'icône.
 *     Si la ligature n'est pas dans LIBELLES : ON NE TOUCHE À RIEN.
 *     Mieux vaut un nom médiocre (« menu ») qu'un nom inventé, et surtout
 *     jamais une commande sans aucun nom (WCAG 4.1.2).
 *
 * Volontairement ABSENTES de LIBELLES : toutes les flèches (arrow_forward,
 * arrow_back, keyboard_arrow_*). Une commande réduite à une flèche n'a pas de
 * destination devinable ; elle garde le comportement actuel.
 */
(function () {
  'use strict';

  /* Ligatures réellement présentes dans ce thème sur des commandes qui n'ont
     aucun autre texte. Vérifié dans sections/header.liquid (menu),
     snippets/search-popup.liquid (search, close),
     snippets/header-actions.liquid (account_circle, réglage account_icon),
     snippets/quantity-selector.liquid (add, remove). */
  var LIBELLES = {
    menu: 'Ouvrir le menu',
    close: 'Fermer',
    search: 'Rechercher',
    account_circle: 'Mon compte',
    person: 'Mon compte',
    add: 'Augmenter la quantité',
    remove: 'Diminuer la quantité'
  };

  /* Ce qui est réellement atteignable au clavier. */
  var COMMANDES =
    'a[href],area[href],button,summary,[role="button"],[role="link"],[tabindex]:not([tabindex^="-"])';

  /* Composants FullStack qui ne sont PAS focusables : des custom elements sans
     tabindex ni rôle. Un aria-label y serait ignoré (élément sans rôle) et
     masquer leur icône les laisserait sans aucun texte. On les laisse donc
     strictement tels quels — leur correction demande de toucher les snippets
     FullStack (cart-icon.liquid, wishlist-icon.liquid,
     add-to-wishlist-button.liquid) et sort de ce lot. */
  var A_IGNORER = 'cart-icon,wishlist-header-icon,add-to-wishlist-button';

  function texteHorsIcones(element) {
    var copie = element.cloneNode(true);
    var icones = copie.querySelectorAll('span.icon');
    for (var i = 0; i < icones.length; i++) {
      icones[i].parentNode.removeChild(icones[i]);
    }
    return (copie.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function dejaNomme(element) {
    return (
      (element.getAttribute('aria-label') || '').trim() !== '' ||
      (element.getAttribute('aria-labelledby') || '').trim() !== '' ||
      (element.getAttribute('title') || '').trim() !== ''
    );
  }

  function traiter(racine) {
    if (!racine || !racine.querySelectorAll) return;

    var icones = racine.querySelectorAll('span.icon:not([data-a11y-traite])');

    for (var i = 0; i < icones.length; i++) {
      var icone = icones[i];
      icone.setAttribute('data-a11y-traite', '');

      if (icone.closest(A_IGNORER)) continue;

      var commande = icone.closest(COMMANDES);

      if (!commande) {
        icone.setAttribute('aria-hidden', 'true'); /* règle 1 */
        continue;
      }

      if (dejaNomme(commande) || texteHorsIcones(commande) !== '') {
        icone.setAttribute('aria-hidden', 'true'); /* règle 2 */
        continue;
      }

      var libelle = LIBELLES[(icone.textContent || '').trim()];
      if (!libelle) continue; /* règle 3 : pas de nom sûr, on s'abstient */

      commande.setAttribute('aria-label', libelle);
      icone.setAttribute('aria-hidden', 'true');
    }
  }

  function demarrer() {
    traiter(document.body);

    /* L'éditeur de thème redessine les sections, et le tiroir panier, la
       recherche et la wishlist injectent du HTML après coup : on repasse sur
       les nouveaux nœuds. On n'observe que childList, jamais les attributs,
       donc nos propres setAttribute ne rappellent pas l'observateur. */
    if (typeof MutationObserver !== 'function') return;

    var enAttente = false;
    var observateur = new MutationObserver(function () {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(function () {
        enAttente = false;
        traiter(document.body);
      });
    });
    observateur.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
